import http from '../utils/request.js'

/**
 * API 服务示例
 * 根据实际项目需求修改接口地址和参数
 */

// 用户相关API
export const userApi = {
  // 用户登录
  login(data) {
    return http.post('/auth/login', data)
  },

  // 用户注册
  register(data) {
    return http.post('/auth/register', data)
  },

  // 获取用户信息
  getUserInfo() {
    return http.get('/user/info')
  },

  // 更新用户信息
  updateUserInfo(data) {
    return http.put('/user/info', data)
  },

  // 修改密码
  changePassword(data) {
    return http.put('/user/password', data)
  }
}

// 商品相关API
export const productApi = {
  // 获取商品列表
  getProductList(params) {
    return http.get('/products', params)
  },

  // 获取商品详情
  getProductDetail(id) {
    return http.get(`/products/${id}`)
  },

  // 添加商品
  addProduct(data) {
    return http.post('/products', data)
  },

  // 更新商品
  updateProduct(id, data) {
    return http.put(`/products/${id}`, data)
  },

  // 删除商品
  deleteProduct(id) {
    return http.delete(`/products/${id}`)
  },

  // 上传商品图片
  uploadProductImage(formData) {
    return http.upload('/products/upload', formData)
  }
}

// 订单相关API
export const orderApi = {
  // 获取订单列表
  getOrderList(params) {
    return http.get('/orders', params)
  },

  // 获取订单详情
  getOrderDetail(id) {
    return http.get(`/orders/${id}`)
  },

  // 创建订单
  createOrder(data) {
    return http.post('/orders', data)
  },

  // 更新订单状态
  updateOrderStatus(id, status) {
    return http.put(`/orders/${id}/status`, { status })
  },

  // 取消订单
  cancelOrder(id) {
    return http.put(`/orders/${id}/cancel`)
  },

  // 收银系统创建订单
  createCashierOrder(data) {
    return http.post('/cashier/order/create', data)
  },

  // 收银系统获取订单列表
  getCashierOrderList(params) {
    return http.get('/cashier/order/list', params)
  },

  // 订单退款
  refundOrder(data) {
    return http.post('/cashier/order/refund', data)
  }
}

// 库存相关API
export const inventoryApi = {
  // 获取库存列表
  getInventoryList(params) {
    return http.get('/inventory', params)
  },

  // 更新库存
  updateInventory(id, data) {
    return http.put(`/inventory/${id}`, data)
  },

  // 库存出入库
  stockMovement(data) {
    return http.post('/inventory/movement', data)
  },

  // 获取库存记录
  getStockRecords(params) {
    return http.get('/inventory/records', params)
  }
}

// 会员相关API
export const memberApi = {
  // 获取会员列表
  getMemberList(params) {
    return http.get('/cashier/member/list', params)
  },

  // 获取会员详情
  getMemberDetail(id) {
    return http.get('/cashier/member/detail', { id })
  },

  // 添加会员
  addMember(data) {
    return http.post('/cashier/member/create', data)
  },

  // 更新会员信息
  updateMember(data) {
    return http.put('/cashier/member/update', data)
  },

  // 删除会员
  deleteMember(id) {
    return http.delete('/cashier/member/delete', { id })
  },

  // 会员积分操作
  memberPointsOperation(id, data) {
    return http.post(`/members/${id}/points`, data)
  }
}

// 统计相关API
export const statsApi = {
  // 获取销售统计
  getSalesStats(params) {
    return http.get('/stats/sales', params)
  },

  // 获取商品统计
  getProductStats(params) {
    return http.get('/stats/products', params)
  },

  // 获取会员统计
  getMemberStats(params) {
    return http.get('/stats/members', params)
  },

  // 获取库存统计
  getInventoryStats(params) {
    return http.get('/stats/inventory', params)
  }
}

// 文件上传API
export const uploadApi = {
  // 上传单个文件
  uploadFile(formData) {
    return http.upload('/upload/file', formData)
  },

  // 上传多个文件
  uploadFiles(formData) {
    return http.upload('/upload/files', formData)
  }
}

// 通用API
export const commonApi = {
  // 获取系统配置
  getConfig() {
    return http.get('/config')
  },

  // 获取字典数据
  getDict(type) {
    return http.get('/dict', { type })
  }
}

export default {
  userApi,
  productApi,
  orderApi,
  inventoryApi,
  memberApi,
  statsApi,
  uploadApi,
  commonApi
}